<template>
  <div class="toggle-button">
    <div class="toggle-button-slot"
         :class="{ 'toggle-button-slot_open' : isOpen}">
      <slot />
    </div>

    <app-button class="text-primary"
                :label="toggleLabel"
                :icon="toggleIcon"
                type="button"
                flat
                small
                underline
                primary
                @click="toggleIsOpen" />
  </div>
</template>

<script>
import AppButton from "@/components/generic/button/Button";

export default {
  components: {
    AppButton,
  },

  props: {
    label: {
      type: Object,
      default() {
        return {
          opened: "",
          closed: "",
        };
      },
    },
    startOpened: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  created() {
    if (this.startOpened) {
      this.isOpen = true;
    }
  },

  computed: {
    toggleLabel() {
      return this.isOpen ? this.label.opened : this.label.closed;
    },
    toggleIcon() {
      return this.isOpen ? "minus-circle" : "plus-circle";
    },
  },

  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-button {
  .toggle-button-slot {
    margin-bottom: 10px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;

    .toggle-button-slot-label {
      font-size: 14px;
      color: #707070;
      flex-shrink: 0;
      font-weight: 600;
      margin: 0;
    }

    .toggle-button-slot-picker {
      display: flex;
      align-items: center;
      border: 1px solid #d6d6d6;
      padding: 5px !important;
      flex: 0 0 70px;
    }

    &.toggle-button-slot_open {
      max-height: 100px;
    }
  }
}
</style>
